export default __webpack_public_path__ + "static/media/bip.0a484062.png";